import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8h-4v8h4","key":"svg-0"}],["path",{"d":"M10 12h2.5","key":"svg-1"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-2"}]]

const IconSquareRoundedLetterE = createReactComponent('outline', 'square-rounded-letter-e', 'SquareRoundedLetterE', __iconNode);

export default IconSquareRoundedLetterE;